import { useEffect, useState } from "react";
import { SAVED_EVENT } from "./api";

// Returns a counter that bumps after any save (this tab or another tab), on window focus, and every 30 s.
// Add it to a page's data-loading useEffect deps to auto-refresh.
export function useRefreshTick(intervalMs = 30000) {
  const [tick, setTick] = useState(0);
  useEffect(() => {
    let t;
    const bump = () => { clearTimeout(t); t = setTimeout(() => setTick((x) => x + 1), 400); };
    const onFocus = () => { if (document.visibilityState === "visible") bump(); };
    window.addEventListener(SAVED_EVENT, bump);
    window.addEventListener("focus", onFocus);
    document.addEventListener("visibilitychange", onFocus);
    const iv = setInterval(() => { if (document.visibilityState === "visible") setTick((x) => x + 1); }, intervalMs);
    return () => { clearTimeout(t); clearInterval(iv); window.removeEventListener(SAVED_EVENT, bump); window.removeEventListener("focus", onFocus); document.removeEventListener("visibilitychange", onFocus); };
  }, [intervalMs]);
  return tick;
}
